import { Injectable, OnDestroy } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Observable, Subscription } from 'rxjs';
import {fromPromise} from "rxjs/internal/observable/innerFrom";

@Injectable({
  providedIn: 'root',
})
export class ModalService implements OnDestroy {
  private subscriptions: Subscription[] = [];
  private modal: HTMLIonModalElement | null = null;

  constructor(private modalController: ModalController) {}

  public showModal(component, props, cssClass?: string) {
    this.modalController.create({
      component,
      componentProps: props,
      cssClass,
    }).then((modal) => {
      this.modal = modal;
      modal.animated = false;
      modal.present();
    });
  }

  public dismissModal() {
    this.modal?.dismiss();
    this.modal = null;
  }

  showModalNew(
    component,
    props,
    cssClass?: string
  ): Observable<HTMLIonModalElement> {
    return fromPromise(
      this.modalController.create({
        component,
        componentProps: props,
        cssClass,
      })
    );
  }

  public dismissModalNew(modal: HTMLIonModalElement) {
    fromPromise(modal.dismiss()).subscribe().unsubscribe();
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subs) => subs.unsubscribe());
  }
}
